import $axios from '../../../lib/http';

import userEquipmentInfo from '../../../lib/userEquipmentInfo.js';
const { infoPhone } = userEquipmentInfo();

class originalApi {
  async getHomeApi(successCb: Function, errorCb: Function) {
    // ##书城-原创-首页
    try {
      const res = await $axios.post(
        `/originalbook/originallist`,
        `value=${encodeURI(
          JSON.stringify({
            ...infoPhone,
            type: 'originallist',
            body: {},
          })
        )}`
      );
      if (res.data.result === '0000') {
        successCb(res.data.body);
      }
    } catch (e) {
      errorCb && errorCb(e);
    }
  }
}

export default new originalApi();
